/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UserRouteImport } from './routes/user'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UserIndexRouteImport } from './routes/user/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as UserHistoryRouteImport } from './routes/user/history'
import { Route as ErrorsDownRouteImport } from './routes/errors/down'
import { Route as ErrorsDeniedRouteImport } from './routes/errors/denied'
import { Route as UserBillsIndexRouteImport } from './routes/user/bills/index'
import { Route as UserBillsCurrentRouteImport } from './routes/user/bills/current'
import { Route as UserBillsBillIdRouteImport } from './routes/user/bills/$billId'

const UserRoute = UserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserIndexRoute = UserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UserRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserHistoryRoute = UserHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => UserRoute,
} as any)
const ErrorsDownRoute = ErrorsDownRouteImport.update({
  id: '/errors/down',
  path: '/errors/down',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorsDeniedRoute = ErrorsDeniedRouteImport.update({
  id: '/errors/denied',
  path: '/errors/denied',
  getParentRoute: () => rootRouteImport,
} as any)
const UserBillsIndexRoute = UserBillsIndexRouteImport.update({
  id: '/bills/',
  path: '/bills/',
  getParentRoute: () => UserRoute,
} as any)
const UserBillsCurrentRoute = UserBillsCurrentRouteImport.update({
  id: '/bills/current',
  path: '/bills/current',
  getParentRoute: () => UserRoute,
} as any)
const UserBillsBillIdRoute = UserBillsBillIdRouteImport.update({
  id: '/bills/$billId',
  path: '/bills/$billId',
  getParentRoute: () => UserRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/user': typeof UserRouteWithChildren
  '/errors/denied': typeof ErrorsDeniedRoute
  '/errors/down': typeof ErrorsDownRoute
  '/user/history': typeof UserHistoryRoute
  '/admin': typeof AdminIndexRoute
  '/user/': typeof UserIndexRoute
  '/user/bills/$billId': typeof UserBillsBillIdRoute
  '/user/bills/current': typeof UserBillsCurrentRoute
  '/user/bills': typeof UserBillsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/errors/denied': typeof ErrorsDeniedRoute
  '/errors/down': typeof ErrorsDownRoute
  '/user/history': typeof UserHistoryRoute
  '/admin': typeof AdminIndexRoute
  '/user': typeof UserIndexRoute
  '/user/bills/$billId': typeof UserBillsBillIdRoute
  '/user/bills/current': typeof UserBillsCurrentRoute
  '/user/bills': typeof UserBillsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/user': typeof UserRouteWithChildren
  '/errors/denied': typeof ErrorsDeniedRoute
  '/errors/down': typeof ErrorsDownRoute
  '/user/history': typeof UserHistoryRoute
  '/admin/': typeof AdminIndexRoute
  '/user/': typeof UserIndexRoute
  '/user/bills/$billId': typeof UserBillsBillIdRoute
  '/user/bills/current': typeof UserBillsCurrentRoute
  '/user/bills/': typeof UserBillsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/user'
    | '/errors/denied'
    | '/errors/down'
    | '/user/history'
    | '/admin'
    | '/user/'
    | '/user/bills/$billId'
    | '/user/bills/current'
    | '/user/bills'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/errors/denied'
    | '/errors/down'
    | '/user/history'
    | '/admin'
    | '/user'
    | '/user/bills/$billId'
    | '/user/bills/current'
    | '/user/bills'
  id:
    | '__root__'
    | '/'
    | '/callback'
    | '/user'
    | '/errors/denied'
    | '/errors/down'
    | '/user/history'
    | '/admin/'
    | '/user/'
    | '/user/bills/$billId'
    | '/user/bills/current'
    | '/user/bills/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CallbackRoute: typeof CallbackRoute
  UserRoute: typeof UserRouteWithChildren
  ErrorsDeniedRoute: typeof ErrorsDeniedRoute
  ErrorsDownRoute: typeof ErrorsDownRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/user': {
      id: '/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof UserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/': {
      id: '/user/'
      path: '/'
      fullPath: '/user/'
      preLoaderRoute: typeof UserIndexRouteImport
      parentRoute: typeof UserRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/history': {
      id: '/user/history'
      path: '/history'
      fullPath: '/user/history'
      preLoaderRoute: typeof UserHistoryRouteImport
      parentRoute: typeof UserRoute
    }
    '/errors/down': {
      id: '/errors/down'
      path: '/errors/down'
      fullPath: '/errors/down'
      preLoaderRoute: typeof ErrorsDownRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/errors/denied': {
      id: '/errors/denied'
      path: '/errors/denied'
      fullPath: '/errors/denied'
      preLoaderRoute: typeof ErrorsDeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/bills/': {
      id: '/user/bills/'
      path: '/bills'
      fullPath: '/user/bills'
      preLoaderRoute: typeof UserBillsIndexRouteImport
      parentRoute: typeof UserRoute
    }
    '/user/bills/current': {
      id: '/user/bills/current'
      path: '/bills/current'
      fullPath: '/user/bills/current'
      preLoaderRoute: typeof UserBillsCurrentRouteImport
      parentRoute: typeof UserRoute
    }
    '/user/bills/$billId': {
      id: '/user/bills/$billId'
      path: '/bills/$billId'
      fullPath: '/user/bills/$billId'
      preLoaderRoute: typeof UserBillsBillIdRouteImport
      parentRoute: typeof UserRoute
    }
  }
}

interface UserRouteChildren {
  UserHistoryRoute: typeof UserHistoryRoute
  UserIndexRoute: typeof UserIndexRoute
  UserBillsBillIdRoute: typeof UserBillsBillIdRoute
  UserBillsCurrentRoute: typeof UserBillsCurrentRoute
  UserBillsIndexRoute: typeof UserBillsIndexRoute
}

const UserRouteChildren: UserRouteChildren = {
  UserHistoryRoute: UserHistoryRoute,
  UserIndexRoute: UserIndexRoute,
  UserBillsBillIdRoute: UserBillsBillIdRoute,
  UserBillsCurrentRoute: UserBillsCurrentRoute,
  UserBillsIndexRoute: UserBillsIndexRoute,
}

const UserRouteWithChildren = UserRoute._addFileChildren(UserRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CallbackRoute: CallbackRoute,
  UserRoute: UserRouteWithChildren,
  ErrorsDeniedRoute: ErrorsDeniedRoute,
  ErrorsDownRoute: ErrorsDownRoute,
  AdminIndexRoute: AdminIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
